import React from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import { EnumCalzada } from '../../../Utils/Enumeradores/ComunEnum';

const formatDate = (value) => value ? moment(value).format('DD-MM-YYYY HH:mm:ss') : '';
const indicadoresConHectometros = [5, 4, 1];

const obtenerFilasDetalle = (datosModal = {}) => {
	const macroubicaciones = Array.isArray(datosModal.macroubicaciones) ? datosModal.macroubicaciones : [];
	const mostrarHectometros = indicadoresConHectometros.includes(datosModal.indicadorId);

	return macroubicaciones.flatMap((macroubicacion) => {
		const macroubicacionMostrar = `${macroubicacion.idMacroubicacion || ''}${macroubicacion.descripcion ? ` - ${macroubicacion.descripcion}` : ''}`;
		const planElementos = Array.isArray(macroubicacion.planElementos) ? macroubicacion.planElementos : [];
		const planHectometros = Array.isArray(macroubicacion.planHectometros) ? macroubicacion.planHectometros : [];

		if (!mostrarHectometros && planElementos.length > 0) {
			return planElementos.map((elemento) => ({
				tipo: 'elemento',
				id: elemento.idBIM || elemento.idBim || elemento.elementoId || elemento.planElementoId || '',
				descripcion: elemento.descripcion || elemento.elementoDescripcion || '',
				km: elemento.kmElemento || elemento.km || '',
				calzada: EnumCalzada[elemento.calzada] || elemento.calzada || '',
				macroubicacion: macroubicacionMostrar
			}));
		}

		return planHectometros.map((hectometro) => ({
			tipo: 'hectometro',
			id: hectometro.hectometro || '',
			kmInicial: hectometro.pkInicialHectometro ?? '',
			kmFinal: hectometro.pkFinalHectometro ?? '',
			macroubicacion: macroubicacionMostrar
		}));
	});
};

const ModalDetalleCargaInformes = ({ show, onHide, datosModal = {} }) => {
	const filasDetalle = obtenerFilasDetalle(datosModal);
	const tieneDetalleConsolidado = filasDetalle.length > 0;
	const mostrarHectometros = indicadoresConHectometros.includes(datosModal.indicadorId);
	const etiquetaElementosInvolucrados = mostrarHectometros
		? 'Hectómetros Involucrados'
		: 'Elementos Involucrados';
	const camposDetalle = [
		['ID', datosModal.planConservacionId],
		['Fecha Planificada de Carga', formatDate(datosModal.fechaPlanificada)],
		['Fecha Real de Carga', formatDate(datosModal.fechaCarga)],
		['Días de Incumplimiento', datosModal.diasIncumplimiento],
		['Estado', datosModal.estadoPlan],
		['Año', datosModal.ano],
		['Trimestre', datosModal.trimestre],
		['Indicador', datosModal.indicador],
		['Exigencia', datosModal.exigencia],
		...(tieneDetalleConsolidado ? [] : [[etiquetaElementosInvolucrados, datosModal.hmEleInvolucrados]]),
		['Cantidad de Registros', datosModal.cantidadRegistros],
		['Estado', datosModal.estadoPlan],
		['Usuario', datosModal.usuario],
		['Observaciones', datosModal.observaciones],
		...(tieneDetalleConsolidado ? [[etiquetaElementosInvolucrados, null, true]] : []),
	];

	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			dialogClassName="bitacora-finding-modal carga-informes-detail-modal"
			contentClassName="bitacora-finding-modal__content"
		>
			<div className="bitacora-finding-modal__shell">
				<div className="bitacora-finding-modal__header justify-content-end">
					<button type="button" className="bitacora-finding-modal__close" onClick={onHide} aria-label="Cerrar">
						<i className="ico-close"></i>
					</button>
				</div>
				<div className="bitacora-finding-modal__title">
					<strong>Plan de conservación {datosModal.planConservacionId || ''}</strong>
					<span>{datosModal.indicador || ''}</span>
				</div>
				<div className="bitacora-finding-modal__section">
					<h6>Detalle</h6>
					<ul>
						{camposDetalle.map(([label, value, esTituloTabla], index) => (
							<li key={`${label}-${index}`} className={esTituloTabla ? 'carga-informes-detail-modal__table-label' : ''}>
								<strong>{label}:</strong>{!esTituloTabla && <span className="text-break"> {value ?? ''}</span>}
							</li>
						))}
					</ul>
					{tieneDetalleConsolidado &&
						<div className="accordion-body p-0 brd-top carga-informes-detail-modal__table">
							<table className="table table-sm" border="1">
								<thead>
									<tr>
										{mostrarHectometros ?
											<>
												<th>Hectómetro</th>
												<th>Km Inicial Hectómetro</th>
												<th>Km Final Hectómetro</th>
												<th>Macroubicación</th>
											</>
											:
											<>
												<th>IdBIM</th>
												<th>Descripción</th>
												<th>Km Elemento</th>
												<th>Calzada</th>
												<th>Macroubicación</th>
											</>
										}
									</tr>
								</thead>
								<tbody>
									{filasDetalle.map((row, index) => (
										<tr key={`${row.tipo}-${row.id}-${index}`}>
											{mostrarHectometros ?
												<>
													<td>{row.id}</td>
													<td>{row.kmInicial}</td>
													<td>{row.kmFinal}</td>
													<td>{row.macroubicacion}</td>
												</>
												:
												<>
													<td>{row.id}</td>
													<td>{row.descripcion}</td>
													<td>{row.km}</td>
													<td>{row.calzada}</td>
													<td>{row.macroubicacion}</td>
												</>
											}
										</tr>
									))}
								</tbody>
							</table>
						</div>
					}
				</div>
			</div>
		</Modal>
	);
};

export default ModalDetalleCargaInformes;
